
const navigate = [
  {
    "_data": "shops",
    "title": "Магазины",
    "icon": "icon-shops",
    "path": "/shops",
    "permissions": ["shop.get", "shop.list"]
  },
  {
    "_data": "operations",
    "icon": "icon-operations",
    "title": "Операции",
    "path": "/operations/invoices",
    "permissions": ["operation.get"]
  },
  {
    "_data": "accounts",
    "icon": "icon-accounts",
    "title": "Балансы",
    "path": "/accounts",
    "permissions": ["shop.balances.get"],
    "userType": ["INDIVIDUAL", "SUBAGGREGATOR", "C2CMARKETPLACE"]
  },
  {
    "_data": "billing.operations",
    "icon": "icon-reports",
    "title": "Выписка",
    "path": "/billing/operations",
    "permissions": ["billing.operation.get"]
  },
  {
    "_data": "acts",
    "title": "Акты и реестры",
    "icon": "icon-registries",
    "path": "/acts",
    "userType": ["LEGAL", "ST"],
    "permissions": ["act.get"]
  },
  {
    "_data": "finance",
    "icon": "icon-promo",
    "title": "Финансирование",
    "path": "/finance",
    "permissions": ["finance.get"]
  },
  // {
  //   "_data": "about",
  //   "icon": "icon-about",
  //   "title": "О компании",
  //   "path": "/about",
  //   "permissions": ["merchant.get"]
  // },
  {
    "_data": "options",
    "icon": "icon-settings",
    "title": "Настройки",
    "path": "/options",
    "permissions": ["user.get"]
  },

  'delimiter',

  {
    "_data": "faq",
    "icon": "icon-support",
    "title": "Вопросы и ответы",
    "path": "/faq",
  },
  {
    "_data": "started",
    "title": "Приступая к работе",
    "icon": "icon-dashboard",
    "path": "/getting-started",
  },
  {
    "_data": "whats.new",
    "icon": "icon-help",
    "title": "Что нового",
    "path": "/whats-new",
    hasNew: true,
  },
];

export default navigate;
